const normalizeNodes = (node, newContacts, entityId) =>
	node.map((entity) => {
		const matches = entity?.entityId === entityId;
		const newNodes = entity?.nodes?.length > 0 ? normalizeNodes(entity.nodes, newContacts, entityId) : [];
		return {...entity, contacts: matches ? newContacts : entity?.contacts, nodes: newNodes};
	});

export default (orgChart, {body = null, entities = null}) => {
	if (body?.entityOperation === undefined) return orgChart;

	const entityId = body?.entityId;
	const newContacts = [...entities?.find((entity) => entity?.entityId === entityId)?.contacts];

	return normalizeNodes([...orgChart], newContacts, entityId);
};
